var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExamCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.79099 1.88647C10.0019 1.67559 10.0019 1.33368 9.791 1.12279C9.58012 0.911903 9.23821 0.911898 9.02733 1.12278L3.84334 6.30661L1.12078 3.58405C0.909894 3.37317 0.567985 3.37317 0.357102 3.58405C0.146219 3.79494 0.146219 4.13685 0.357102 4.34773L3.4613 7.45193C3.56267 7.5533 3.69431 7.60594 3.82713 7.60985C3.97073 7.61419 4.11574 7.56155 4.22534 7.45195L9.79099 1.88647Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExamCheck);
export default __webpack_public_path__ + "static/media/exam_check.4578e683ecca621f3c88fa5ea8c3a638.svg";
export { ForwardRef as ReactComponent };